import { formatNumber } from '@angular/common';

export function numberFormatter(dataItemValue: number, locale: string = 'en-NZ') {
  return formatNumber(dataItemValue, locale);
}
